import {observable, action} from 'mobx';
import _ from 'lodash';
class AlertStore {

  @observable event = {};

  @action success = (text, time) => {
    this.event = _.assign({text: text, type: 'success',time: time})
  };

  @action error = text => {
    this.event = _.assign({text: text, type: 'error'})
  };

  @action info = text => {
    this.event = _.assign({text: text, type: 'info'})
  };

}

export default new AlertStore();



// WEBPACK FOOTER //
// ./src/stores/AlertStore.js